/**
 * @module SetupJestTest
 */

/**
 * Convenience function to define window.analytics when it does not exist.
 */
function defineAnalytics() {
  if (!window.analytics) {
    Object.defineProperty(window, 'analytics', {
      value: {
        identify: jest.fn(),
        page: jest.fn(),
        screen: jest.fn(),
        track: jest.fn(),
        user: jest.fn(() => {
          return {
            anonymousId: jest.fn(),
          };
        }),
      },
    });
  }
}

/**
 * Convenience function to define window.gtag when it does not exist.
 */
function defineGtag() {
  if (!window.gtag) {
    Object.defineProperty(window, 'gtag', {
      value: jest.fn(),
    });
  }
}

/**
 * Convenience function to set up hook mocks for tests.
 */
function setupHookMocks() {
  // AuthContext + useAuth().
  jest.mock('@lifechurch/web-tools-io/dist/hooks/useAuth', () => {
    return jest.fn(() => ({
      checkLogin: jest.fn(),
      checkSession: jest.fn((callback) => {
        if (callback) {
          callback();
        }
      }),
      configure: jest.fn(),
      getAccessToken: jest.fn(),
      handleAuthentication: jest.fn(),
      isAuthenticated: false,
      isError: false,
      isIdle: true,
      isLoading: false,
      isOrganization: false,
      isSuccess: true,
      isUserChecked: true,
      logIn: jest.fn(),
      logOut: jest.fn(),
      user: null,
    }));
  });

  // useWindowSize().
  jest.mock('@lifechurch/web-tools-io/dist/hooks/useWindowSize', () => {
    return jest.fn(() => ({
      breakpoints: {
        large: 1024,
        medium: 768,
        small: 640,
        xLarge: 1200,
      },
      height: 800,
      isDesktop: true,
      isMobile: false,
      isTablet: false,
      width: 1280,
    }));
  });
}

/**
 * Convenience function to set up Web Tools IO component mocks for tests.
 */
function setupWebToolsMocks() {
  /**
   * Mock the Log utility exposed from browserLogger.
   */
  jest.mock(
    '@lifechurch/web-tools-io/dist/utils/helpers/browserLogger',
    () => ({
      Log: {
        error: jest.fn(),
        info: jest.fn(),
        log: jest.fn(),
        warn: jest.fn(),
      },
    }),
  );
}

/**
 * Convenience function to setup Jest test environment variables and methods.
 */
function setupJest() {
  defineAnalytics();
  defineGtag();
  setupHookMocks();
  setupWebToolsMocks();
}

module.exports = {
  setupJest,
};
